import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  margin: auto;
  padding-bottom: 1rem;
  background: ${({ theme }) => theme.colors.white};
  padding-left: 1.5rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    margin-bottom: 1.5rem;
  }
`;

export const SearchAndActionsBlock = styled.div`
  width: 100%;
  margin-top: 1rem;
  display: flex;
  flex-wrap: wrap;

  & > .actions {
    width: 100%;
    margin-top: 1.5rem;
    display: flex;
    justify-content: flex-start;

    & > button:first-child {
      margin-right: 0.5rem;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-wrap: unset;

    & > .select-container {
      margin-right: 1.5rem;
    }
  }
`;

export const FilterContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;

  & > header {
    width: 4.125rem;
    height: 2rem;
    left: 1.5rem;
    top: 0;
    font-style: normal;
    font-weight: 600;
    font-size: 1.5rem;
    line-height: 2rem;
    color: ${({ theme }) => theme.colors.grayDark3};

    margin-top: 0.5rem;
    margin-bottom: 1rem;

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      margin-bottom: unset;
    }
  }

  & > div.inputs-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 1rem;

    @media (min-width: ${({ theme }) => theme.breakpoints.laptop}) {
      flex-direction: row;
    }

    & > div {
      display: flex;
      align-items: center;
      flex-direction: column;
      bottom: 0.8rem;

      @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        flex-direction: row;
      }

      & > .hefesto-button--secondary {
        margin-top: 1.5rem;
        width: 10.75rem;
        height: 3.125rem;
        justify-content: center;
      }
    }
  }
`;

export const OrderFilterBlock = styled.div`
  display: flex;

  & > button {
    width: 10.75rem;
    height: fit-content;
    margin: 1.6rem 1rem 0 0;
  }

  & > div {
    flex: 1;
    width: 100%;

    &.order-status > .ant-select {
      width: 100%;
    }

    &.product-type > .ant-select {
      width: 100%;
    }
  }

  & > div {
    &.hefesto-select-container {
      width: auto;
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: 96%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    .select-container {
      width: 16.875rem;
    }

    & > div:not(:last-child) {
      margin-right: 1.5rem;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.laptopM}) {
    & > div {
      margin-right: 1.5rem;
    }
  }
`;
